import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import { GlobalVars } from '../../../../../../shared/global-vars';
import { ChartData, DataDepth } from '../../../../../../shared/models/depth-data';
import { DataResult } from '../../../../../../shared/models/chart-forecast-data';
import { subDays } from 'date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ResultValue, SourceData } from '../../../../../../shared/models/source-data';


@Component({
  selector: 'app-source-chart',
  templateUrl: './source-chart.component.html',
  styleUrl: './source-chart.component.scss'
})
export class SourceChartComponent {
    @Input() chartData: SourceData | null = null;
    chart: any;
  
    constructor() {}
  
    ngOnInit(): void {
      Chart.register(zoomPlugin);
      if (this.chartData) {
        this.updateChart();
      }
    }
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['chartData'] && this.chartData && this.chartData.result) {
        this.updateChart();
      }
    }
  
    updateChart() {
      if (!this.chartData) {
        return;
      }
      this.drawChart();
    }
  
    drawChart() {
      if (this.chart) {
        this.chart.destroy();
      }
  
      const datasets = this.getDatasets();
  
      const ctx = document.getElementById('chart') as HTMLCanvasElement;
      if (!ctx) {
        console.error('Failed to acquire chart context');
        return;
      }
  
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: false,
              text: '',
              font: {
                size: 18
              }
            },
            legend: {
              display: false
            },
            zoom: {
              zoom: {
                wheel: {
                  enabled: true,
                },
                pinch: {
                  enabled: true,
                },
                mode: 'xy'
              },
              pan: {
                enabled: true
              },
              limits: {
                x: { min: 'original', max: 'original' },
                y: { min: 'original', max: 'original' }
              }
            },
            tooltip: { 
              callbacks: { 
                label: (tooltipItem) => { 
                  const value = tooltipItem.formattedValue; 
                  return ` Débit : ${value} L/s`; 
                } 
              }
            }
          },
          interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false
          },
          scales: {
            x: {
              display: false,
              type: 'time',
              time: {
                unit: 'day',
                tooltipFormat: 'dd/MM/yyyy',
                displayFormats: {
                  day: 'dd/MM/yyyy'
                }
              },
              title: {
                display: true,
                text: ''
              },
              ticks: {
                font: {
                  size: 10
                }
              },
              stacked: true
            },
            y: {
              display: false,
              title: {
                display: true,
                text: ''
              },
              stacked: true
            },
          },
          layout: {
            padding: 0,
          }
        }
      });
    }
  
    getDatasets() {
      let allDatasets: any = [];
      if(this.chartData?.typeData === "debit") {
        allDatasets.push(this.createDataset('debit', this.chartData.result, '#007bff'));
      }
      return allDatasets;
    }
  
    createDataset(label: string, data: ResultValue[], color: string) {
      return {
        label: label,
        data: data.map(d => ({ x: new Date(d.date), y: d.value })),
        borderColor: color,
        backgroundColor: this.hexToRgba(color, 0.25),
        borderWidth: 2,
        fill: false,
        tension: 0.1,
        pointRadius: 2,
      };
    }

    hexToRgba(hex: string, alpha: number): string {
      hex = hex.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  
  
}
